import { Component, Inject, OnInit, ViewChild, ElementRef, AfterViewInit, OnDestroy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ApiService } from 'src/app/services/api.service';
import KeenSlider, { KeenSliderInstance } from "keen-slider";
@Component({
  selector: 'fury-cover-item-details-modal',
  templateUrl: './cover-item-details-modal.component.html',
  styleUrls: ['./cover-item-details-modal.component.scss']
})
export class CoverItemDetailsModalComponent implements OnInit, AfterViewInit, OnDestroy {

  imgPath: any;
  logoConfigcontent = {
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    infinite: false,
    dots: false,
    autoplay: false,
    autoplaySpeed: 1000,
    cssEase: 'linear',
  };
  @ViewChild("sliderRef") sliderRef!: ElementRef<HTMLElement>
  slider!: KeenSliderInstance;
  currentSlide: number = 0;

  constructor(public dialogRef: MatDialogRef<CoverItemDetailsModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public api: ApiService
  ) { 
    
  }

  ngOnInit(): void {
   }

  closePop() {
    this.dialogRef.close();
  }
  ngAfterViewInit(): void {
    setTimeout(()=>{
      this.slider = new KeenSlider(
        this.sliderRef.nativeElement,
        {
          slides: {
            perView: 1,
          },
          loop: false,
          initial: this.currentSlide,
          slideChanged: (s) => {
            this.currentSlide = s.track.details.rel
          },
        },
      );
    })
  }

  ngOnDestroy() {
    if (this.slider) this.slider.destroy();
  }


}
